import { render, staticRenderFns } from "./UpdateProductTagDialog.vue?vue&type=template&id=8126f1a2&scoped=true"
import script from "./UpdateProductTagDialog.vue?vue&type=script&lang=js"
export * from "./UpdateProductTagDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateProductTagDialog.vue?vue&type=style&index=0&id=8126f1a2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8126f1a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8126f1a2')) {
      api.createRecord('8126f1a2', component.options)
    } else {
      api.reload('8126f1a2', component.options)
    }
    module.hot.accept("./UpdateProductTagDialog.vue?vue&type=template&id=8126f1a2&scoped=true", function () {
      api.rerender('8126f1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/UpdateProductTagDialog.vue"
export default component.exports